import React, { useEffect, useState } from 'react'
import BAutoComplete from './BAutoComplete'
import { getOptionLabel } from '../../_Helper/AutoCompleteGetLabel';
import { countries, getStates } from '../../_Helper/CountryStateCity';
import { FormLabel } from '@mui/material';
import I18n from '../../i18n/i18n';

export default function FieldStateSelector(props) {
    const {
        labelComponent,
        label,
        serviceType,
        required,
        disabled,
        onChange,
        value,
        countryCode } = props

    const [states, setStates] = useState([]);

    useEffect(() => {
        fetch('/data/state.json').then(data =>
            data.json().then(x => {
                setStates(x)
            }))
    }, [])

    return (
        <>
            {labelComponent ? labelComponent :
                <FormLabel required={required ?? true}>
                    <I18n id={label} serviceType={serviceType} />
                </FormLabel>}

            <BAutoComplete
                disabled={disabled}
                value={value}
                onChange={(e, selected) => onChange(selected)}
                options={getStates(states , countryCode)}
                {...props}
                required={required ?? true}
            />
        </>
    )
}
